"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsEnum = void 0;
const yup_1 = require("yup");
const errors_1 = require("../../errors");
const validation_1 = require("../../validation");
exports.IsEnum = (myEnum) => (target, propertyKey) => validation_1.Validation.registerCustomValidation(target, propertyKey, yup_1.mixed().oneOf(getAllValsFromEnum(myEnum), errors_1.FormError.notAllowedValue));
const getAllValsFromEnum = (myEnum) => {
    return Object.keys(myEnum).reduce((res, key) => myEnum[key] ? [...res, myEnum[key]] : res, []);
};
//# sourceMappingURL=is-enum.decorator.js.map